import ForgotPassword from 'components/pages/ForgotPassword/ForgotPassword';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');

export default buildPage(ForgotPassword, {
  skipSSR: true,
  metaData: {
    title: 'Forgot password',
    description: 'Forgot your password? No problem! Reset it here.',
  },
  loggedInRedirect: '/dashboard',
});
